import { useParams } from 'react-router';

import { useFarmCanBeEdited, useUserFarmActions } from '../utils/hooks';

const useReadonly = () => {
  const { farmId } = useParams();
  const { canEdit } = useUserFarmActions(farmId);
  const farmCanBeEdited = useFarmCanBeEdited(farmId);
  return !canEdit || !farmCanBeEdited;
};

export default useReadonly;
